module.exports = __webpack_public_path__ + "media/public/images/slider/prev-2e8ec37f8d13595920bd1e0c0663e704.png";